export const en = {
    title: 'Add documents',
    description: 'They are needed to buy tickets and book hotels',
    add_later: 'Maybe later',
    add_now: 'Add',
};
